import React from "react";

import ErrorContainer from "./ErrorContainer";

const Select = ({
  label,
  formRegister,
  formError,
  formKey,
  optionsArray,
  onChange,
  notRequired,
  deactivate,
}) => {
  return (
    <li className={deactivate ? "deactivate-input" : ""}>
      <label className={notRequired ? "" : "required"}>{label}</label>
      <div class={`select-div input-group `}>
        <select {...formRegister(formKey)} onChange={onChange}>
          <option value="">Select</option>
          {optionsArray?.map((el) => {
            return <option value={el?.value}>{el?.label}</option>;
          })}
        </select>
        {<ErrorContainer errors={formError} name={formKey} />}
      </div>
    </li>
  );
};

export default Select;
